function Resume() {

  return (
    <section aria-labelledby="resume-header">
      <h2 id="resume-header">Resume</h2>
      <h2>Scott Casey</h2>
      <p>
        Salt Lake City, UT
      </p>
      <p>
        <strong>(702) 813-4210</strong>
      </p>
      <p>
        <strong>scaseydv@gmail.com</strong>
      </p>
      <h3>EXPERIENCE</h3>


      <h4>Self-Employed — Character sheet Author</h4>


      <p>
        May 2016 - PRESENT
      </p>
      <p>
        Designed and created digital versions of physical books with an emphasis on responsiveness and accessibility. Lead client’s efforts to standardize digital creations and implement test driven development.
      </p>
      <h4>University of Utah, Salt lake City— Lab Manager</h4>


      <p>
        August 2020 - June 2021
      </p>
      <p>
        Supervised day to day functioning of a research lab. Designed and executed experiments and managed lab resources and training.
      </p>
      <h4>MD Anderson Cancer Center, Austin TX — Research Assistant II, Graduate Research Assistant, Research Assistant I</h4>


      <p>
        June 2014 - July 2020
      </p>
      <p>
        Designed and executed experimental protocols.
      </p>
      <h3>PROJECTS</h3>


      <h4>Scion on Roll20 — https://marketplace.roll20.net/browse/bundle/19378/scion</h4>


      <p>
        PUG, SCSS, Javascript
      </p>
      <p>
        Designed and implemented a digital character sheet and compendium data structure to enable players to easily shift from playing at a physical table to a VTT.
      </p>
      <h4>Genefunk on Roll20 — https://marketplace.roll20.net/browse/search?keywords=genefunk</h4>


      <p>
        PUG , CSS, Javascript
      </p>
      <p>
        Designed and implemented a digital character sheet and compendium data structure to enable players to easily shift from playing at a physical table to a VTT.
      </p>
      <h4>K-Scaffold — https://kurohyou.github.io/Roll20-Snippets/</h4>


      <p>
        PUG, SCSS, Javascript
      </p>
      <p>
        Designed a framework for developing Roll20 character sheets that simplifies the connection between character attributes and the javascript that powers advanced sheet features. The scaffold also provides several ready built components for commonly used character sheet constructions.
      </p>
      <h3>EDUCATION</h3>


      <h4>University of Utah Full Stack Bootcamp, Salt Lake City — Certificate</h4>


      <p>
        June 2022  - November 2022
      </p>
      <h4>MD Anderson GSBS, Houston TX — Master’s</h4>


      <p>
        July 2015 - December 2019
      </p>
      <h3>Tools</h3>


      <p>
        Vue, React
      </p>
      <h3>Programming Languages</h3>


      <p>
        HTML, CSS, Javascript, PUG, SCSS
      </p>
    </section>
  )
};
export default Resume;